import React, { useState } from 'react';
import { useTranslation } from '../i18n';

const API_URL = process.env.REACT_APP_API_URL ?? 'http://localhost:5000/api';

export default function ContactModal({ isOpen, onClose }) {
  const { t } = useTranslation();
  const [status, setStatus] = useState('idle');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('sending');
    const data = new FormData(e.target);
    try {
      const res = await fetch(`${API_URL}/contact`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          name: data.get('name'),
          email: data.get('email'),
          message: data.get('message'),
        }),
      });
      if (res.ok) {
        setStatus('success');
      } else {
        setStatus('error');
      }
    } catch {
      setStatus('error');
    }
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="contact-modal" onClick={(e) => e.stopPropagation()}>
        <button type="button" className="modal-close" onClick={onClose}>
          <span className="material-symbols-outlined">close</span>
        </button>
        <h2>{t('contact.title')}</h2>
        {status === 'success' ? (
          <p className="modal-success">{t('contact.success')}</p>
        ) : (
          <form onSubmit={handleSubmit}>
            <input type="text" name="name" placeholder={t('contact.namePlaceholder')} required />
            <input type="email" name="email" placeholder={t('contact.emailPlaceholder')} required />
            <textarea name="message" placeholder={t('contact.messagePlaceholder')} required rows={5} />
            <button type="submit" disabled={status === 'sending'}>
              {status === 'sending' ? t('contact.sending') : t('contact.send')}
            </button>
          </form>
        )}
        {status === 'error' && <p className="modal-error">{t('contact.error')}</p>}
      </div>
    </div>
  );
}
